import React, { Component } from "react";

import { Button, CardBody, Col, Row } from "reactstrap";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import _ from "lodash";
import ModalForm from "../ModalForm/ModalForm";

class Modals extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            {/* <CardBody> */}
            <Modal
              isOpen={this.props.modal}
              toggle={this.props.toggle}
              className={"modal-lg"}
              backdrop={"static"}
            >
              <ModalHeader toggle={this.props.toggle}>
                Registration Form
                </ModalHeader>
              <ModalBody>
                <ModalForm
                  handleOnChange={this.props.handleOnChange}
                  vendorFirstName={this.props.vendorFirstName}
                  vendorLastName={this.props.vendorLastName}
                  vendorEmail={this.props.vendorEmail}
                  vendorPassword={this.props.vendorPassword}
                  vendorRepeatPassword={this.props.vendorRepeatPassword}
                  vendorMobileNumber={this.props.vendorMobileNumber}
                  vendorVerifyOtp={this.props.vendorVerifyOtp}
                  vendorVerifyOtpSection={this.props.vendorVerifyOtpSection}
                  onRegistrationMobileChangeHandler={this.props.onRegistrationMobileChangeHandler}
                  registrationOtpButtonText={this.props.registrationOtpButtonText}
                  sendRegistrationOtpHandler={this.props.sendRegistrationOtpHandler}
                  vendorRegistrationHandler={this.props.vendorRegistrationHandler}
                  onOtpChangeHandler={this.props.onOtpChangeHandler}
                  handleallServicesChange={this.props.handleallServicesChange}
                  selectedOption={this.props.selectedOption}
                  options={this.props.options}
                />
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={this.props.toggle}>
                  Close
                  </Button>
              </ModalFooter>
            </Modal>
            {/* </CardBody> */}
          </Col>
        </Row>
      </div>
    );
  }
}

export default Modals;
